import {
  GridRenderEditCellParams,
  useGridApiContext,
} from "@mui/x-data-grid-premium";
import { TextField, Popover, Box } from "@mui/material";
import { useRef, useEffect, useState, useReducer } from "react";

export function trimWithEllipses(text: string, width = 100) {
  if (!text) return text;

  return (
    <div
      style={{
        width: `${width}px`,
        overflow: "visible",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
      title={text}
    >
      {text}
    </div>
  );
}

export function FullWidthEditInput(props: GridRenderEditCellParams) {
  const { id, value, field, colDef, hasFocus } = props;

  const [open, setOpen] = useState(false);

  const apiRef = useGridApiContext();
  const cellRef = useRef<HTMLDivElement>(null);

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value || null;
    apiRef.current.setEditCellValue({ id, field, value: newValue });
  };

  useEffect(() => {
    if (hasFocus) {
      setOpen(true);
    }
  }, [hasFocus]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Box
        ref={cellRef}
        onClick={handleOpen}
        sx={{ width: "100%", height: "100%", cursor: "text" }}
      >
        {value || ""}
      </Box>
      {cellRef.current && (
        <Popover
          open={open}
          anchorEl={cellRef.current}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              sx: {
                width: 600,
                p: 2,
              },
            },
          }}
        >
          <TextField
            value={value || ""}
            onChange={handleValueChange}
            autoFocus
            fullWidth
            minRows={3}
            maxRows={15}
            variant="outlined"
            label={colDef.headerName || field}
            placeholder="Enter text..."
            sx={{
              "& .MuiInputBase-root": {
                fontSize: "inherit",
              },
            }}
          />
        </Popover>
      )}
    </>
  );
}
